import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const neroConfig: TSPConfig = {
  key: 'nero',
  name: 'NERO',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please input the username and password you use to log into the Portal.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default neroConfig;
